export default "__VITE_ASSET__DES0nPgR__"